import { SiteAlarmSetting } from "utils/models/location-alarms";
import { getTestResults } from "utils/services/idbService";

export async function getAlarmsFromCache(siteId: number): Promise<SiteAlarmSetting[]> {

    let existingIndex;

    let allData = await getTestResults(
        `allSites`,
        localStorage.getItem('currentUser') ?? 'unknown'
    );

    let site = allData.find((site: {id: number}) => site.id === siteId);

    let cachedKits = await getTestResults(
        `defaultTestKits`,
        localStorage.getItem('currentUser') ?? 'unknown'
    );

    let siteAlarmSettings = [] as SiteAlarmSetting[];
    let locationAlarmSettings;

    for (let location of site.sampleLocationAllVOs) {

        let activeKits = cachedKits.filter((kit: {id: number}) => location.testKitIDs.includes(kit.id));

        locationAlarmSettings = activeKits.flatMap((testKit: any) => {

            return testKit.fieldDescriptorAllVOs
                .filter((fieldDesc: any) => fieldDesc.type && (fieldDesc.type.localeCompare("Output") === 0) && !fieldDesc.hidden)
                .map((fieldDesc: any) => ({
                    locationName: location.name,
                    testKitId: testKit.id,
                    fieldId: fieldDesc.outputId,
                    hiHiAlarm: fieldDesc.hiHiAlarmValue,
                    hiAlarm: fieldDesc.hiAlarmValue,
                    loAlarm: fieldDesc.loAlarmValue,
                    loLoAlarm: fieldDesc.loLoAlarmValue
                }))

        });

        for (let alarmVO of location.customAlarmVOs) {

            let siteAlarmSetting = {
                locationName: location.name,
                testKitId: alarmVO.testKitId,
                fieldId: alarmVO.outputId,
                hiHiAlarm: alarmVO.hiHiAlarmValue,
                hiAlarm: alarmVO.hiAlarmValue,
                loAlarm: alarmVO.loAlarmValue,
                loLoAlarm: alarmVO.loLoAlarmValue
            } as SiteAlarmSetting;

            existingIndex = locationAlarmSettings.findIndex((defaultAlarm: SiteAlarmSetting) =>
                defaultAlarm.locationName === siteAlarmSetting.locationName &&
                defaultAlarm.testKitId === siteAlarmSetting.testKitId &&
                defaultAlarm.fieldId === siteAlarmSetting.fieldId
            );

            if (existingIndex > -1) {
                locationAlarmSettings[existingIndex] = siteAlarmSetting;
            } else {
                locationAlarmSettings.push(siteAlarmSetting);
            }

        }

        siteAlarmSettings = siteAlarmSettings.concat(locationAlarmSettings);

    }

    return siteAlarmSettings;
}